import sendRequest from "@/libs/sendRequest"

const customerLeads = {
    namespaced: true,
    state: {
        lead: {},
        leads: [],
        error: false,
        last_page: null,
        total_pages: null
    },
    getters: {
        getLead: (state) => state.lead,
        getLeads: (state) => state.leads,
        getLastPage: (state) => state.last_page,
        getTotalPages: (state) => state.total_pages,
        getError: (state) => state.error
    },
    mutations: {
        setLead: (state, payload) => state.lead = payload,
        setLeads: (state, payload) => state.leads = payload,
        setLastPage: (state, payload) => state.last_page = payload,
        setTotalPages: (state, payload) => state.total_pages = payload,
        setError: (state, payload) => state.error = payload
    },
    actions: {
        list: async ({ commit, dispatch, rootGetters }, query) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/customer-leads/list', 'GET', null, query, custom_headers)

            if (response.success && response.data) {
                if (query.datatable) {
                    commit('setLeads', response.data.list.result)
                    commit('setTotalPages', response.data.list.total_pages)
                    commit('setLastPage', response.data.list.total_pages == query.page)
                } else {
                    commit('setLeads', response.data.list)
                }
                dispatch('hiddenLoading', null, { root: true })
            } else if (!response.success && response.errors) {
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', 'An error has occurred, try later', { root: true })
            } else if (!response.success && !response.data) {
                dispatch('lostConection', null, { root: true })
            }
        },
        view: async ({ commit, dispatch, rootGetters }, query) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/customer-leads/view', 'GET', null, query, custom_headers)

            if (response.success && response.data) {
                commit('setLead', response.data.view)
                dispatch('hiddenLoading', null, { root: true })
            } else if (!response.success && response.errors) {
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', 'An error has occurred, try later', { root: true })
            } else if (!response.success && !response.data) {
                dispatch('lostConection', null, { root: true })
            }
        },
        updateStatus: async ({ commit, dispatch, rootGetters }, { id_lead, status }) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/customer-leads/update-status', 'PATCH', { status }, { id_lead }, custom_headers)

            if (response.success && response.data) {
                dispatch('showAlert', 'Status updated successfully', { root: true })
                commit('setError', false)
                dispatch('hiddenLoading', null, { root: true })
            } else if (!response.success && response.errors) {
                commit('setError', true)
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', 'An error has occurred, try later', { root: true })
            } else if (!response.success && !response.data) {
                dispatch('lostConection', null, { root: true })
            }
        }
    }
}

export default customerLeads
